import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M20.8,10h-1.6V7.2c0-3.7-3-6.7-6.7-6.7c-3.7,0-6.7,3-6.7,6.7V10H4.3C3.6,10,3,10.6,3,11.3v12 c0,0.7,0.6,1.3,1.3,1.3h16.6c0.7,0,1.3-0.6,1.3-1.3v-12C22.1,10.6,21.5,10,20.8,10z M13.6,18.7v1c0,0.5-0.5,0.9-1.1,0.9 c-0.6,0-1.1-0.4-1.1-0.9v-1c-0.8-0.4-1.4-1.2-1.4-2.2c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5C15,17.5,14.5,18.3,13.6,18.7z  M17.5,10H7.6V7.2c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9V10z" />
    </g>
  </svg>
);
